import React from "react";
import * as styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";

import { GameStatusContext } from "../../providers/GameStatusProvider";

function WordButton({ word, fullCandidateSize }) {
  const { guessCandidate, setGuessCandidate } =
    React.useContext(GameStatusContext);
  const [isSelected, setIsSelected] = React.useState(
    !!guessCandidate.includes(word)
  );

  const isCandidateListFull = guessCandidate.length == fullCandidateSize;

  React.useEffect(() => {
    setIsSelected(!!guessCandidate.includes(word));
  }, [guessCandidate]);

  function flipSelection() {
    if (isSelected) {
      // remove from candidateGuess
      const updatedGuessCandidate = guessCandidate.filter((w) => {
        return w !== word;
      });
      setGuessCandidate(updatedGuessCandidate);
      // set state to *not* selected
      setIsSelected(false);
    } else {
      // check if the candidate array is full
      if (!isCandidateListFull) {
        // add to candidateGuess array
        setGuessCandidate([...guessCandidate, word]);
        // set state to *selected*
        setIsSelected(true);
      }
    }
  }

  const containerRef = React.useRef(null);
  const textRef = React.useRef(null);
  const [scale, setScale] = React.useState(1);

  React.useLayoutEffect(() => {
    const container = containerRef.current;
    const text = textRef.current;
    if (!container || !text) return;

    const fit = () => {
      const cw = container.clientWidth;
      const tw = text.scrollWidth;
      if (tw === 0 || cw === 0) return;
      const next = Math.min(1, cw / tw);
      setScale(next);
    };

    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(container);
    return () => ro.disconnect();
  }, [word]);

  return (
    <Toggle
      className={`${styles.growShrink} select-none aspect-square h-auto w-full p-1 rounded-md border-0 bg-[#efefe6] text-[#3a3a3a] hover:bg-[#dfdfd5] hover:text-white data-[state=on]:!bg-[#5a594e] data-[state=on]:!text-white`}
      variant="default"
      pressed={isSelected}
      onClick={flipSelection}
    >
      <div
        ref={containerRef}
        className="w-full overflow-hidden flex items-center justify-center"
      >
        <p
          ref={textRef}
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "center",
          }}
          className="font-sans font-extrabold uppercase text-sm sm:text-base tracking-wide text-center leading-tight whitespace-nowrap"
        >
          {word.split(/\s+/).map((segment, i, arr) => (
            <React.Fragment key={i}>
              {segment}
              {i < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      </div>
    </Toggle>
  );
}

export default WordButton;
